import script from "./BaseField.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseField.vue?vue&type=script&setup=true&lang=js"

import "./BaseField.vue?vue&type=style&index=0&id=c2cd9256&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2cd9256"]])

export default __exports__